import React from "react"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import "../styles/NoPage.css"
class NoPage extends React.Component {
  render() {
    return (
      <div>
   <Navbar /> 
   <section class="error-container">
  <span class="four"><span class="screen-reader-text">4</span></span>
  <span class="zero"><span class="screen-reader-text">0</span></span>
  <span class="four"><span class="screen-reader-text">4</span></span>
</section>
   <h1>Sorry, this page isn't available.</h1>
   
{/* <p class="zoom-area"><b>CSS</b> animations to make a cool 404 page. </p> */}

<div class="link-container">
  <a target="_blank" href="/" class="more-link">Go back Home</a>
</div>

<br></br>
<br></br>
<br></br>

       <Footer />
      </div>
    )
  }
}
export default NoPage